import React, { useState, useRef } from 'react';
import { useMutation } from '@apollo/client';
import SignatureCanvas from 'react-signature-canvas';
import { UPDATE_DEFAULT_TITLE_RELEASE } from './queries';

export default function DefaultTitleRelease() {
  const [form, setForm] = useState({
    titleOwnerName: '',
    titleShippingAddress1: '',
    titleShippingAddress2: '',
    titleCity: '',
    titleState: '',
    titleZip: '',
    defaultTitleReleaseSignature: '',
  });

  const sigCanvas = useRef();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [updateDefaultTitleRelease, { data, loading, error }] = useMutation(
    UPDATE_DEFAULT_TITLE_RELEASE
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleClearSignature = () => {
    sigCanvas.current?.clear();
    setForm({ ...form, defaultTitleReleaseSignature: '' });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const signatureData = sigCanvas.current?.isEmpty()
      ? ''
      : sigCanvas.current?.toDataURL();

    updateDefaultTitleRelease({
      variables: {
        ...form,
        defaultTitleReleaseSignature: signatureData,
      },
    }).then((result) => {
      if (
        !result.errors &&
        !result.data?.updateDefaultTitleRelease?.errors?.length
      ) {
        setIsSubmitted(true);
      }
    });
  };

  // Inline Thank You component
  const ThankYou = () => (
    <div style={{
      maxWidth: 600,
      margin: '0 auto',
      padding: 20,
      textAlign: 'center',
      border: '1px solid #ccc',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9'
    }}>
      <h2>Thank You!</h2>
      <p style={{ marginBottom: '30px' }}>
        We have received your Default Title Release Information. We will process this shortly.
      </p>
      <a
        href="/account/profile"
        style={{
          display: 'inline-block',
          padding: '10px 20px',
          backgroundColor: '#c00',
          color: '#fff',
          textDecoration: 'none',
          borderRadius: '4px'
        }}
      >
        Return Home
      </a>
    </div>
  );

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: 20 }}>
      {isSubmitted ? (
        <ThankYou />
      ) : (
        <>
          <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>
            Default Title Release Information
          </h2>
          <form
            onSubmit={handleSubmit}
            style={{
              display: 'grid',
              gridTemplateColumns: '150px 1fr',
              gap: '12px',
              alignItems: 'center',
              backgroundColor: '#f9f9f9',
              padding: '20px',
              borderRadius: '8px',
              border: '1px solid #ccc',
            }}
          >
            <label>Title Owner Name</label>
            <input
              type="text"
              name="titleOwnerName"
              value={form.titleOwnerName}
              onChange={handleChange}
            />

            <label>Shipping Address 1</label>
            <input
              type="text"
              name="titleShippingAddress1"
              value={form.titleShippingAddress1}
              onChange={handleChange}
            />

            <label>Shipping Address 2</label>
            <input
              type="text"
              name="titleShippingAddress2"
              value={form.titleShippingAddress2}
              onChange={handleChange}
            />

            <label>City</label>
            <input
              type="text"
              name="titleCity"
              value={form.titleCity}
              onChange={handleChange}
            />

            <label>State</label>
            <input
              type="text"
              name="titleState"
              value={form.titleState}
              onChange={handleChange}
            />

            <label>Zip</label>
            <input
              type="text"
              name="titleZip"
              value={form.titleZip}
              onChange={handleChange}
            />

            <label style={{ gridColumn: '1 / -1', marginTop: '20px' }}>
              Digital Signature
            </label>
            <div
              style={{
                border: '2px solid black',
                backgroundColor: '#f8f8f8',
                padding: '10px',
                gridColumn: '1 / -1',
                borderRadius: '4px',
              }}
            >
              <p style={{ margin: 0, fontStyle: 'italic', color: '#555' }}>
                Please sign below
              </p>
              <SignatureCanvas
                penColor="black"
                canvasProps={{
                  width: 500,
                  height: 200,
                  className: 'sigCanvas',
                  style: {
                    border: '1px solid #ccc',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                  },
                }}
                ref={sigCanvas}
              />
              <div style={{ marginTop: '8px' }}>
                <button
                  type="button"
                  onClick={handleClearSignature}
                  style={{ marginRight: '10px' }}
                >
                  Clear Signature
                </button>
              </div>
            </div>

            <div style={{ gridColumn: '1 / -1', textAlign: 'center', marginTop: '20px' }}>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#c00',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                {loading ? 'Saving...' : 'Save Default Title Release'}
              </button>
            </div>
          </form>

          {error && (
            <p style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>
              Error: {error.message}
            </p>
          )}

          {data?.updateDefaultTitleRelease?.errors?.length > 0 && (
            <div style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>
              {data.updateDefaultTitleRelease.errors.map((err, idx) => (
                <div key={idx}>{err.message}</div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
